import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQuery(queryParamName) {
  const { search } = useLocation();
  const memoizedSearch = useMemo(() => Object.fromEntries(new URLSearchParams(search)), [search]);

  if (!search) return null;
  return queryParamName ? memoizedSearch[queryParamName] : memoizedSearch;
}
